import { render } from "./SidemenuCm.vue?vue&type=template&id=d9b7cd48"
import script from "./SidemenuCm.vue?vue&type=script&lang=js"
export * from "./SidemenuCm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__